angular.module('signalview.detector.notification', []);
